/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from 'react'

const useDebounce = <T>(value: T, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return debouncedValue
}

export default useDebounce

// eslint-disable-next-line @typescript-eslint/ban-types
export function debounce<T extends Function>(
  func: T,
  delay: number,
): (...args: any[]) => void {
  let timeoutId: ReturnType<typeof setTimeout>
  // eslint-disable-next-line func-names
  return function (this: any, ...args: any[]) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      func.apply(context, args)
    }, delay)
  }
}
